import { FaDownload, FaEllipsisH, FaFilter, FaUpload } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaFileExport, FaFileInvoice, FaFilePdf, FaInfoCircle, FaMoneyBillWave, FaPlus, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import BonLivraisonForm from './BonLivraisonForm';
import InvoiceForm from './InvoiceForm';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { generateDoc } from '../../helpers/generateDoc';

const DeliveryList = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);

    const handleDownloadExcelTemplate = () => {
        const wsData = [
            [
                'N° BL',
                'client',
                'Date operation',
                'désignation',
                'code à barre',
                'unité mesure',
                'prix unitaire ttc',
                'quantité'
            ],
            // Example: Passager
            ['BL001', '', '18/08/2025', 'Produit Passager', '1234567890123', 'PCS', '100.00', '2'],
            // Example: Particulier
            ['BL002', 'Karim El Fassi', '18/08/2025', 'Produit Particulier', '9876543210987', 'PCS', '150.00', '1'],
            // Example: Entreprise
            ['BL003', 'Société ABC', '18/08/2025', 'Produit Entreprise', '5555555555555', 'BOX', '200.00', '5'],
        ];
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'BL_Template');
        XLSX.writeFile(wb, 'BL_Import_Template.xlsx');
    };

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    }, [filters]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    icon: 'error',
                    title: t('product.invalidFileType'),
                    text: t('product.excelOnly'),
                });
                return;
            }

            try {
                const formData = new FormData();
                formData.append('file', file);

                let payload = {
                    formData: formData,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: t('delivery.uploadSuccess'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#198754'
                        });
                        refrechBLs();
                    },
                }
                dispatch(deliveryActions.uploadBLs(payload));

            } catch (error) {
                console.error('Error parsing Excel:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: "Erreur lors de l'importation des produits",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    // Handle creating an invoice from selected deliveries
    const handleCreateInvoice = () => {
        if (checkedDeliveries.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.noDeliveriesSelected'),
            });
            return;
        }

        // Get the selected delivery notes
        const selectedDeliveryNotes = list.filter(note => checkedDeliveries.includes(note.id));

        // Check if all selected delivery notes are from the same client and are in confirmed state
        const firstClient = selectedDeliveryNotes[0].clientId;
        const allSameClient = selectedDeliveryNotes.every(note => note.clientId === firstClient);
        const allConfirmed = selectedDeliveryNotes.every(note => note.status === 'LIVRE');

        if (!allSameClient) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentClients'),
            });
            return;
        }



        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notAllDelivered'),
            });
            return;
        }

        // Prepare the invoice object
        const newInvoice = {
            clientId: selectedDeliveryNotes[0].clientId,
            clientNom: selectedDeliveryNotes[0].clientNom,
            deliveryMappings: selectedDeliveryNotes.map(note => ({
                id: note.id,
                numero: note.numero,
                dateLivraison: note.dateLivraison,
                montantTTC: note.montantTotalTTC,
                montantPaye: note.montantPaye
            })),
            lignes: (() => {
                // Aggregate lines by articleId
                const lineMap = {};
                selectedDeliveryNotes.forEach(note => {
                    note.lignes.forEach(line => {
                        const key = line.articleId;
                        if (!lineMap[key]) {
                            lineMap[key] = {
                                articleId: line.articleId,
                                articleCode: line.articleCode,
                                articleNom: line.articleNom,
                                unite: line.unite,
                                prixUnitaireHT: line.prixUnitaireHT,
                                prixUnitaireTTC: line.prixUnitaireTTC,
                                tauxTVA: line.tauxTVA,
                                quantite: 0,
                                montantHT: 0,
                                montantTVA: 0,
                                montantTTC: 0,
                            };
                        }

                        lineMap[key].quantite += line.quantiteLivree;
                        lineMap[key].montantHT += line.quantiteLivree * line.prixUnitaireHT;
                        lineMap[key].montantTVA += line.quantiteLivree * line.prixUnitaireHT * line.tauxTVA;
                        lineMap[key].montantTTC += line.quantiteLivree * line.prixUnitaireHT * (1 + line.tauxTVA);
                    });
                });
                return Object.values(lineMap);
            })(),

            montantTotalHT: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalHT, 0),
            montantTotalTaxe: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTaxe, 0),
            montantTotalTTC: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTTC, 0),
            montantTotalPaye: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            montantRegle: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            modePaiement: selectedDeliveryNotes[0].modePaiement,
            modeReglement: selectedDeliveryNotes[0].modeReglement,
            dateFacture: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0], // Current date in YYYY-MM-DD format
            dateEcheance: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0], // Current date in YYYY-MM-DD format
            // dateEcheanceCheque: selectedDeliveryNotes[0].dateEcheanceCheque,
            // banque: selectedDeliveryNotes[0].banque,
            // numeroCheque: selectedDeliveryNotes[0].numeroCheque,
        };

        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedDeliveries([]); // Clear checked deliveries after closing the invoice modal
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const handleGeneratePdf = async (document, documentType = 'bon_livraison', withPrices = true) => {
        await generateDoc(documentType, {
            matjarDoc: document,
            sellerModel: company,
            currency: "MAD",
            showPrices: withPrices,         // false pour BL sans prix
            open: true,               // ouvre dans un nouvel onglet
            download: false,          // si true -> télécharge
        });
    };


    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleEdit = (bl) => {
        setSelectedBonLivraison(bl);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedBonLivraison) {
            setSelectedBonLivraison(null);
        }
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(deliveryActions.list({
                ...filters,
                query: query
            }));
        }, 1500), // Wait 1.5 seconds after user stops typing
        [filters.query]
    );

    const handleLivrerBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmLivrer'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, status: 'LIVRE' },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const handleAccuseBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmAccuser'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, accuse: true },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const getPaymentStatusBadge = (document) => {
        const montantPaye = document.montantPaye || 0;
        const montantTotal = document.montantTotalTTC || 0;

        if (montantPaye === 0) {
            return <Badge color="danger">{t('reglement.impaye')}</Badge>;
        } else if (montantPaye < montantTotal) {
            return <Badge color="warning">{t('reglement.partiel')}</Badge>;
        } else {
            return <Badge color="success">{t('reglement.paye')}</Badge>;
        }
    };


    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('delivery.list')}
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                <Button color="primary" onClick={() => fileInputRef.current.click()}>
                                    <FaUpload className="me-2" /> {t('delivery.importer')}
                                </Button>
                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('delivery.new')}
                                </Button>
                                {checkedDeliveries.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('delivery.createInvoice')}
                                    </Button>
                                )}
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleFileUpload}
                                    accept=".xlsx,.xls"
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={4} md={4} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                        debouncedSearch(value);
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>


                                    {/* <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="commercialId" className="mb-1">Commercial</Label>
                                            <Select
                                                id="commercialId"
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(option => option.value === filters?.commercialId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, commercialId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('commercial.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col> */}
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>                            {/* Summary Statistics Box */}


                            <table className="table table-hover table-striped table-bordered" >
                                <thead className="thead-light">
                                    <tr>
                                        {/* Add checkbox column */}
                                        <th className="align-middle text-center" width="20">
                                            <div className="form-check">
                                                <Input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Only select deliveries that are in LIVRE status
                                                            const deliveredIds = list
                                                                .filter(bl => bl.status === 'LIVRE' && !bl.estFacture)
                                                                .map(bl => bl.id);
                                                            setCheckedDeliveries(deliveredIds);
                                                        } else {
                                                            setCheckedDeliveries([]);
                                                        }
                                                    }}
                                                    checked={
                                                        checkedDeliveries.length > 0 &&
                                                        checkedDeliveries.length === list.filter(bl => bl.status === 'LIVRE' && !bl.estFacture).length
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('delivery.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('delivery.vendeur')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('reglement.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((bl) => (
                                        <tr key={bl.id}>
                                            {/* Add checkbox for each row */}
                                            <td className="align-middle text-center">
                                                {bl.status === 'LIVRE' && !bl.estFacture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedDeliveries.includes(bl.id)}
                                                        onChange={() => handleCheckboxChange(bl.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>

                                            <td className="align-middle text-center">{bl.dateOperation || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.createdBy || 'N/A'}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantPaye, false)}</td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                {getPaymentStatusBadge(bl)}
                                            </td>


                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {/* Add dropdown for PDF options */}
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm"
                                                            className='me-1'>
                                                            <FaFilePdf />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', true)}>
                                                                {t('delivery.pdfWithPrices')}
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', false)}>
                                                                {t('delivery.pdfWithoutPrices')}
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                    {bl.status === 'EN_PREPARATION' && <Button
                                                        color="success"
                                                        title={t('bonLivraison.livrer')}
                                                        onClick={() => handleLivrerBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    {/* {bl.status === 'LIVRE' && !bl.accuse && <Button
                                                        color="success"
                                                        title={t('bonLivraison.accuser')}
                                                        onClick={() => handleAccuseBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>} */}
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    {/*<Button
                                                        color="danger"
                                                        title={t('commande.cancel')}
                                                        //onClick={() => handleDeleteDevis(commande.id)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button> */}

                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="19" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="7" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantPaye || 0), 0), false)}</td>
                                        <td colSpan="4"></td>
                                    </tr>
                                </tfoot>

                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}>{selectedBonLivraison ? `${t('bonLivraison.edit')} N° ${selectedBonLivraison.numero}` : t('bonLivraison.new')}</ModalHeader>
                <ModalBody>
                    <BonLivraisonForm bonLivraison={selectedBonLivraison} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>

            {/* Add Invoice Modal */}
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DeliveryList;



